module.exports = __webpack_public_path__ + "img/shoulders.0a547d20.jpg";